import styled, { css } from 'styled-components';
import { ANIMATION_CURVE, ANIMATION_DURATION, FOCUS_OUTLINE_STYLE, getToken } from '@optimus-web/common';
import { BareIconSize } from './types';

export const BareIconButtonElement = styled.button<{ size?: BareIconSize; readOnly?: boolean }>`
    padding: 0;
    background: transparent;
    border: 0;
    cursor: pointer;
    color: ${({ readOnly }) => (readOnly ? getToken('textStaticSecondary') : getToken('textStaticPrimary'))};
    transition-property: color;
    transition-timing-function: ${ANIMATION_CURVE.default};
    transition-duration: ${ANIMATION_DURATION.fast}ms;
    height: ${({ size }) => (size === 'small' ? getToken('sizing200') : getToken('sizing300'))}px;
    width: ${({ size }) => (size === 'small' ? getToken('sizing200') : getToken('sizing300'))}px;
    font-size: 0;

    ${(props) =>
        props.readOnly &&
        css`
            cursor: default;
            pointer-events: none;
        `}

    &:disabled {
        /* Firefox workaround for bubbling events when disabled */
        pointer-events: none;
        color: ${getToken('textDisabled')};
    }

    &:focus {
        ${FOCUS_OUTLINE_STYLE}
        border-radius: ${getToken('borderRadius100')}px;
    }

    &:hover:enabled {
        color: ${getToken('textStaticTertiary')};
    }
`;
